export enum AuthType {
  Identity,
  EntraId,
}